import { text } from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';
import { withInfo } from '@storybook/addon-info';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import { Button } from '../button/button';
import { BackNextSkip } from './backnextskip';

const Red = (props) => <span style={{ color: 'red' }} {...props} />;

const TableComponent = ({ propDefinitions }) => {
  const props = propDefinitions.map(
    ({ property, propType, required, description, defaultValue }) => {
      return (
        <tr key={property}>
          <td>
            {property}
            {required ? <Red>*</Red> : null}
          </td>
          <td>{propType.name}</td>
          <td>{defaultValue}</td>
          <td>{description}</td>
        </tr>
      );
    },
  );

  return (
    <table>
      <thead>
        <tr>
          <th>name</th>
          <th>type</th>
          <th>default</th>
          <th>description</th>
        </tr>
      </thead>
      <tbody>{props}</tbody>
    </table>
  );
};

storiesOf('Back next skip', module).add('default', () => (
  <BackNextSkip
    backButtonClassName={'button button-secondary button-lg'}
    backButtonText={'BACK'}
    // onBackButtonClickHandler={onBackButtonClick}
    nextButtonClassName={'button button-primary button-lg ml-2'}
    nextButtonText={'NEXT'}
  />
));
//   // onNextButtonClickHandler={onNextButtonClick}
//   // skipText={skipText}
//   // onSkipClickHandler={onSkipClick} />;
// );
